import React, { useEffect, useState } from 'react';
import { TableRow } from 'component/Table';
import { squareMetersToHectares } from 'utils/Helper';
import { InteractiveValidationStatus } from 'component/InteractiveValidationStatus';
import { DownloadDocxBtn } from '../Actions/DownloadDocx';
import { UploadPdfBtn } from '../Actions/UploadDownloadPdf';
import { useUser } from 'routes/UserContext';
import './TableRow.scss';

export const TableRowReports = ({
  data,
  formatDate,
  getActionsByRoleAndStatus,
  activeTabIndex,
  setData,
  reportType,
}) => {
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [fileUploadingId, setFileUploadingId] = useState(null);
  const [isFileUploadingPdf, setIsFileUploadingPdf] = useState(false);
  const [fileUploadingIdPdf, setFileUploadingIdPdf] = useState(null);
  const [isImportDropdownOpen, setIsImportDropdownOpen] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const { user } = useUser();

  const canChangeStatus = user?.permissions?.change_settings;

  const updateReportsList = (updatedList) => {
    if (typeof setData === 'function') {
      setData(updatedList);
    } else {
      console.error('setData is not a function:', typeof setData);
    }
  };

  const handleCloseImportDropdown = () => {
    setIsImportDropdownOpen(false);
  };

  const handleClickOutsideModal = (event) => {
    const modal = document.querySelector('.import-dropdown-content');
    if (modal && !modal.contains(event.target)) {
      handleCloseImportDropdown();
    }
  };

  const handleStatusChange = (itemId, newStatus) => {
    const updatedData = data?.map((item) =>
      item?.id === itemId
        ? {
            ...item,
            validation_status: newStatus,
            status_manually_changed: true,
          }
        : item
    );

    updateReportsList(updatedData);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutsideModal);
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideModal);
    };
  }, []);

  return (
    <>
      {data?.map((item, index) => (
        <TableRow key={index}>
          <td style={{ flex: activeTabIndex === 0 ? '120px' : '90px' }}>
            {formatDate(item?.info?.general?.report_date) || '-'}
          </td>

          <td style={{ flex: activeTabIndex === 0 ? '80px' : '100px' }}>
            {item?.info?.general?.team_id || '-'}
          </td>

          <td style={{ flex: activeTabIndex === 0 ? '120px' : '100px' }}>
            {item?.info?.location?.local_community || '-'}
          </td>

          <td style={{ flex: activeTabIndex === 0 ? '90px' : '90px' }}>
            {item?.info?.general?.hazard_name || item?.info?.general?.name || '-'}
          </td>

          <td style={{ flex: activeTabIndex === 0 ? '80px' : '120px' }}>
            {activeTabIndex === 0
              ? item?.info?.nto_result?.village_by_village
                ? 'VBV'
                : 'NTS'
              : item?.info?.general?.hazard_area_type?.includes('SHA')
                ? 'SHA'
                : 'CHA'}
          </td>

          {activeTabIndex === 1 && (
            <>
              <td style={{ flex: '120px' }}>
                {item?.info?.general?.hazard_type?.includes('minefield') ? 'MF' : 'BAC'}
              </td>
              <td style={{ flex: '120px' }}>
                {squareMetersToHectares(item?.info?.turn_points?.total_area_meters) || '-'}
              </td>
            </>
          )}

          <td style={{ flex: activeTabIndex === 0 ? '200px' : '150px' }}>
            {item?.info?.general?.imsma_id || '-'}
          </td>

          <td style={{ flex: '120px' }}>
            <InteractiveValidationStatus
              reportType={reportType}
              reportId={item?.id}
              currentStatus={{
                ...item?.validation_status,
                status_manually_changed: item.status_manually_changed,
              }}
              onStatusChange={handleStatusChange}
              disabled={!canChangeStatus}
            />
          </td>

          <td style={{ flex: activeTabIndex === 0 ? '120px' : '100px' }}>
            <div className="all-icons">{getActionsByRoleAndStatus(item)}</div>
            {activeTabIndex !== 0 &&
              (item?.report_type === 'ha_report' || item?.report_type === 'ha' ? (
                <div className="import-and-export-actions">
                  <DownloadDocxBtn
                    isFileUploading={isFileUploading}
                    fileUploadingId={fileUploadingId}
                    setIsFileUploading={setIsFileUploading}
                    setFileUploadingId={setFileUploadingId}
                    isLoading={isLoading}
                    reportId={item?.id}
                    setIsLoading={setIsLoading}
                  />
                  <UploadPdfBtn
                    reportsList={data || []}
                    isFileUploadingPdf={isFileUploadingPdf}
                    fileUploadingIdPdf={fileUploadingIdPdf}
                    setIsFileUploadingPdf={setIsFileUploadingPdf}
                    setFileUploadingIdPdf={setFileUploadingIdPdf}
                    isImportDropdownOpen={isImportDropdownOpen}
                    setIsImportDropdownOpen={setIsImportDropdownOpen}
                    item={item}
                    onUpdateReportsList={updateReportsList}
                  />
                </div>
              ) : (
                ''
              ))}
          </td>
        </TableRow>
      ))}
    </>
  );
};
